/**
 * Service-worker registration (vite-plugin-pwa injectManifest, src/sw.ts). The worker is registered only in the
 * production build or when VITE_ENABLE_SW=true (dev server, `devOptions`), so day-to-day development and the
 * e2e runs are never served by a cached shell. Phase 10 (offline) reuses this entry point.
 */
export const SW_PATH = import.meta.env.DEV ? '/dev-sw.js?dev-sw' : '/sw.js';
export const SW_SCOPE = '/';

export function swSupported(): boolean {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
}

export function swEnabled(): boolean {
  return import.meta.env.PROD || import.meta.env.VITE_ENABLE_SW === 'true';
}

/**
 * Registers src/sw.ts when enabled; otherwise returns whatever registration already controls the scope
 * (none in a plain dev server → push stays unavailable, see usePush).
 */
export async function registerAppServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!swSupported()) return null;
  if (swEnabled()) {
    return navigator.serviceWorker.register(SW_PATH, {
      type: import.meta.env.DEV ? 'module' : 'classic',
      scope: SW_SCOPE,
    });
  }
  return (await navigator.serviceWorker.getRegistration(SW_SCOPE)) ?? null;
}

/** The current registration without registering anything (logout, badge). */
export async function currentRegistration(): Promise<ServiceWorkerRegistration | null> {
  if (!swSupported()) return null;
  return (await navigator.serviceWorker.getRegistration(SW_SCOPE)) ?? null;
}
